// extracted by mini-css-extract-plugin
module.exports = {"svg":"loft_svg_3A3lk"};